import { createFileRoute } from "@tanstack/react-router"
import { Pricing } from "@/content"

export const Route = createFileRoute("/(public)/pricing")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Pricing />
}
